module.exports = __webpack_public_path__ + "static/media/test6_4.9a7e54a2.png";